<template>
  <div class="flex flex-col items-center justify-center">
    <graphic-base width="100" height="100" view-box="0 0 126 126">
      <circle-email />
    </graphic-base>
    <div
      class="text-center w-4/5 lg:w-3/4 my-12"
      :style="[firstLoginCustomParamsFields.styles.form.textColor]"
    >
      <h1 class="text-zt-xl mb-3 font-medium">
        {{ $t('message.resetPassComponent.mailSentRecover') }}
      </h1>
      <p class="px-4">
        {{ $t('message.resetPassComponent.followStepsRecover') }}
      </p>
    </div>
    <div class="mb-4 w-full">
      <zt-button
        class="w-full opacity-100"
        :style="[firstLoginCustomParamsFields.styles.form.buttons.bgColor]"
        @click="gotoLogin"
        data-vs-button="auth-forgotpass-success-btn-gotologin"
      >
        {{ $t('message.loginComponent.forgetPassword.goBack') }}
      </zt-button>
    </div>
    <div>
      <span :style="[firstLoginCustomParamsFields.styles.form.textColor]">{{
        $t('message.loginComponent.forgetPassword.mailResendMsg')
      }}</span>
      <a @click="mailResend" class="text-zt-secondary-200 ml-1" data-vs-link="auth-forgotpass-link-resendmail">{{
        $t('message.loginComponent.forgetPassword.mailResend')
      }}</a>
    </div>
  </div>
</template>

<script>
import GraphicBase from '@/components/commons/Illustrations/graphicBase'
import CircleEmail from '@/components/commons/Illustrations/graphicSVG/circleEmail'
import Users from '@/apiClient/Users'

export default {
  name: 'ztAuthForgotPassSuccess',
  components: { CircleEmail, GraphicBase },
  props: {
    firstLoginCustomParamsFields: {
      type: Object,
      default: () => {}
    },
    resendParams: {
      type: Object,
      default: () => ({
        userName: '',
        userEmail: ''
      })
    }
  },
  methods: {
    gotoLogin() {
      this.$router.push({ name: 'login' })
    },
    async mailResend() {
      try {
        await this.$recaptchaLoaded()
        await this.$recaptcha('login')
        this.user
          .resetPassRequest(
            this.resendParams.userName,
            this.resendParams.userEmail
          )
          .catch(error => {
            console.error('Error request', error)
          })
      } catch (error) {
        console.error('Captcha Error', error)
      }
    }
  },
  created() {
    this.user = new Users()
  }
}
</script>

<style scoped lang="scss">
::v-deep .zt-button {
  height: 3.25rem;
}
</style>
